import { isEmpty, omitBy } from 'lodash-es';
import { OpportunityKind, RevenueOpportunityListDirection, RevenueOpportunityListSort } from 'anchor-scout-common/types';
import { SearchFilterType } from '~/components/TableFilters/types';
import { describeCard, opportunityBiData, unrecognisedKindReport } from '~/utils/revenueOpportunities/opportunityCard';
import { isKnownOpportunityKind, kindText } from '~/utils/revenueOpportunities/opportunityLabels';
export const SORT_COLUMNS = [
    'client',
    'type',
    'service',
    'confidence',
    'value'
];
const SCOUT_SORT_BY_COLUMN = {
    client: RevenueOpportunityListSort.Client,
    type: RevenueOpportunityListSort.Kind,
    service: RevenueOpportunityListSort.Subject,
    confidence: RevenueOpportunityListSort.Confidence,
    value: RevenueOpportunityListSort.EstAnnualImpact
};
const SCOUT_DIRECTION = {
    asc: RevenueOpportunityListDirection.Asc,
    desc: RevenueOpportunityListDirection.Desc
};
const SCOUT_SEARCH_MAX_LENGTH = 200;
const asSingleCard = (opportunity)=>({
        type: 'single',
        opportunity
    });
const rowOf = (opportunity, texts, position)=>{
    var _opportunity_clientName;
    const view = describeCard(asSingleCard(opportunity), texts);
    return {
        biData: opportunityBiData(view, position),
        id: opportunity.opportunityKey,
        client: (_opportunity_clientName = opportunity.clientName) !== null && _opportunity_clientName !== void 0 ? _opportunity_clientName : texts.unknownClient(),
        type: view.typeLabel,
        service: opportunity.subject,
        confidence: '',
        value: view.rowAmount,
        opportunity,
        confidenceBand: view.confidenceBand,
        confidenceLabel: view.confidenceLabel,
        amount: view.amount,
        lead: view.lead,
        actionLabel: view.actionLabel,
        actionBiName: view.actionBiName
    };
};
export const toRevenueOpportunityRows = (opportunities, texts, firstPosition)=>opportunities.flatMap((opportunity, index)=>isKnownOpportunityKind(opportunity.kind) ? [
            rowOf(opportunity, texts, firstPosition + index)
        ] : []);
export const unrecognisedRowsReport = (opportunities)=>unrecognisedKindReport(opportunities.filter((opportunity)=>!isKnownOpportunityKind(opportunity.kind)).map(asSingleCard));
export const singleCard = (row)=>asSingleCard(row.opportunity);
export const shownOpportunityKeys = (list)=>{
    var _ref;
    return ((_ref = list === null || list === void 0 ? void 0 : list.rows) !== null && _ref !== void 0 ? _ref : []).map((param)=>{
        let { opportunityKey } = param;
        return opportunityKey;
    });
};
const DEFAULT_DIRECTION = {
    client: 'asc',
    type: 'asc',
    service: 'asc',
    confidence: 'desc',
    value: 'desc'
};
export const phoneSortOptions = (columnLabels)=>SORT_COLUMNS.map((column, colIndex)=>({
            id: column,
            label: columnLabels[column],
            defaultDirection: DEFAULT_DIRECTION[column],
            colIndex
        }));
export const phoneFilterConfig = (kindChoices, serviceChoices)=>({
        kind: {
            type: SearchFilterType.MultiSelectFilter,
            options: kindChoices,
            removable: true
        },
        service: {
            type: SearchFilterType.MultiSelectFilter,
            options: serviceChoices,
            removable: true,
            withSearchbox: true
        }
    });
export const phoneFiltersOf = (kinds, serviceKeys)=>omitBy({
        kind: [
            ...kinds
        ],
        service: [
            ...serviceKeys
        ]
    }, isEmpty);
export const tableStateOf = (param)=>{
    let { isLoading, rowCount } = param;
    if (isLoading) {
        return 'loading';
    }
    return rowCount === 0 ? 'empty' : 'default';
};
export const kindOptions = (texts)=>Object.values(OpportunityKind).map((kind)=>({
            value: kind,
            label: kindText(kind, texts.kind)
        }));
export const serviceOptions = (services)=>services.map((param)=>{
        let { serviceKey, subject } = param;
        return {
            value: serviceKey,
            label: subject
        };
    });
export const pageWithin = (page, total, pageSize)=>total == null ? page : Math.min(page, Math.max(1, Math.ceil(total / pageSize)));
export const listQuery = (param)=>{
    let { search, kinds, serviceKeys, sort, page, pageSize } = param;
    return {
        search: search.trim() === '' ? undefined : search.trim().slice(0, SCOUT_SEARCH_MAX_LENGTH),
        kind: kinds.length === 0 ? undefined : kinds,
        serviceKey: serviceKeys.length === 0 ? undefined : serviceKeys,
        sort: sort == null ? undefined : SCOUT_SORT_BY_COLUMN[SORT_COLUMNS[sort.colIndex]],
        direction: sort == null ? undefined : SCOUT_DIRECTION[sort.sort],
        pageSize,
        offset: (page - 1) * pageSize
    };
};
